import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const mapSettingsBoundariesPrimaryBoundaryGroupIdSelector = (state: AppState) => state.map.mapSettings.data.boundaries.primaryBoundaryGroupId;
export const useMapSettingsBoundariesPrimaryBoundaryGroupIdSelector = () => useSelector(mapSettingsBoundariesPrimaryBoundaryGroupIdSelector);

const mapSettingsBoundariesIsolateColor = (state: AppState) => state.map.mapSettings.data.boundaries.isolateColor;
export const useMapSettingsBoundariesIsolateColor = () => useSelector(mapSettingsBoundariesIsolateColor);

export const mapSettingsBoundariesIsolatedBoundariesSelector = (state: AppState) => state.map.mapSettings.data.boundaries.isolatedBoundaries;
export const useMapSettingsBoundariesIsolatedBoundariesSelector = () => useSelector(mapSettingsBoundariesIsolatedBoundariesSelector);
